import { useEffect, ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from '@app/store';
import {
  useGetSessionQuery,
  useGetMeQuery,
  selectIsAuthenticated,
  selectIsInitialized,
  setInitialized,
} from '@entities/session';
import { Spinner } from '@shared/ui';
import styles from './providers.module.css';

interface AuthInitializerProps {
  children: ReactNode;
}

export function AuthInitializer({ children }: AuthInitializerProps) {
  const dispatch = useAppDispatch();
  const isInitialized = useAppSelector(selectIsInitialized);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  // /session устанавливает CSRF и факт авторизации.
  const session = useGetSessionQuery(undefined, { refetchOnMountOrArgChange: true });
  // /me с правами тянем только для авторизованных — анониму он отдаёт 403.
  const me = useGetMeQuery(undefined, { skip: !isAuthenticated });

  useEffect(() => {
    const sessionDone = session.isSuccess || session.isError;
    // Готовы, когда известна сессия и (для авторизованного) загружен профиль:
    // иначе capability-гейты успеют мигнуть на «нет прав».
    const meDone = !isAuthenticated || me.isSuccess || me.isError;
    if (sessionDone && meDone && !isInitialized) {
      dispatch(setInitialized(true));
    }
  }, [
    session.isSuccess,
    session.isError,
    isAuthenticated,
    me.isSuccess,
    me.isError,
    isInitialized,
    dispatch,
  ]);

  if (!isInitialized) {
    return (
      <div className={styles.centeredLoader}>
        <Spinner size="lg" />
      </div>
    );
  }

  return <>{children}</>;
}
